module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vregi10-6540f84aa7e82ce79baaa0e72064ecac.jpg";